/**
 * @description: 获取不重复的随机数
 * @return {string}
 */
export const randomNmber = (): string => {
    return (
        (Math.random() * 10000000).toString(16).substring(0, 4) +
        "_" +
        new Date().getTime() +
        "_" +
        Math.random().toString().substring(2, 7)
    );
};
